import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Box } from '@heycater/design-system';
import styled from 'styled-components';

import { embeddedAssetOptions } from 'hub/helpers/contentful';

function RenderMarkdown({ content }) {
  if (!content) {
    return null;
  }

  return (
    <StyledBox>
      {documentToReactComponents(
        content,
        embeddedAssetOptions(content.links?.assets?.block)
      )}
    </StyledBox>
  );
}

const StyledBox = styled(Box)`
  a {
    color: ${(props) => props.theme.palette.primary.main};
  }
`;

export default RenderMarkdown;
